import { useIsMobile } from '@hooks/mobile'
import { Container } from '@mantine/core'
import React from 'react'

type ContProps = {
  children?: React.ReactNode
  className?: string
  fluid?: boolean
}

const Cont = (props: ContProps) => {
  const { children, fluid, className } = props

  const isMobile = useIsMobile()

  return (
    <Container
      className={`cd-w-full cd-mt-[1rem] cd-mb-[2rem] md:cd-mt-[2rem] md:cd-pb-[4rem] ${className || ''}`}
      fluid={fluid || isMobile}
      size={fluid || isMobile ? '100%' : '95%'}
    >
      {children}
    </Container>
  )
}

export default Cont
